import React, {useState} from "react"

// context and data
import Data from "../../../data"
import Config from "../../../config"

// styling and images
import Images from "../../../images"
import "./PaymentTypes.scss"

import imageInvoice from "../../../images/paymentproviders/invoice.svg";

function PaymentTypes({value}) {
  
  // state management
  const [selectedType, setSelectedType] = useState(value || getDefaultPaymentType())

  // click event handler
  const onClickPaymentType = (e) => {
    if(selectedType !== e.value) {
      setSelectedType(e.value);
      Data.Cart.setPaymentType(e.value);
    }
  }

  // render
  const types = Config.paymentTypes[Config.country].map(t => {
    switch(t) {
      case "stripe":
        return <PaymentType2 key={t} onClick={onClickPaymentType} value="payrexx" selectedValue={selectedType} title="Online" />
      case "payrexx":
        return <PaymentType2 key={t} onClick={onClickPaymentType} value="payrexx" selectedValue={selectedType} title="Online" />
      case "transfer":
      default:
        return <PaymentType key={t} onClick={onClickPaymentType} value="transfer" selectedValue={selectedType} image={imageInvoice} title="Rechnung" info="(zahlbar innert 20 Tagen)" />
    }
  })
  return (
    <div id="v-paymenttypes">
      {types}
    </div>
  )
}

function PaymentType({onClick, value, selectedValue, image, title, info}) {
  return (
    <div
      className={`c-paymenttype ${value === selectedValue ? "selected boxshadow" : ""}`}
      onClick={() => onClick({value:value})}
    >
      <div className="c-paymenttype-text">
        <div className="c-paymenttype-text-title">{title}</div>
        {info ? <div className="c-paymenttype-text-info">{info}</div> : null}
      </div>
      <div className="c-paymenttype-icon">
        <img src={image} alt={title} />
      </div>
    </div>
  )
}

function PaymentType2({onClick, value, selectedValue, title, info}) {
  const icons = Config.paymentProviders.filter(pp => !pp.hideInCheckout).map((pp, index) => {
    return <div key={index}><img key={index} src={pp.image} alt={pp.name} /></div>
  })
  return (
    <div
      className={`c-paymenttype ${value === selectedValue ? "selected boxshadow" : ""}`}
      onClick={() => onClick({value:value})}
    >
      <div className="c-paymenttype-text">
        <div className="c-paymenttype-text-title">{title}</div>
        {info ? <div className="c-paymenttype-text-info">{info}</div> : null}
      </div>
      <div className="c-paymenttype-icons">
        {icons}
      </div>
    </div>
  )
}

function getDefaultPaymentType() {
  // default payment type in switzerland: invoice, germany: credit card
  return Config.country === "ch" ? Config.paymentTypes.ch[0] : Config.paymentTypes.de[0];
}

export default PaymentTypes